import React, { useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import ManagePhotosContainer from "./container";
import { useUploadResPhotosMutation, useDeleteResPhotoMutation } from "../profile/services";
import { setPOSData } from "pages/login/services";
import AddPhotosModal from "../profile/components/AddPhotosModal";

const ManagePhotos = () => {
    const dispatch = useDispatch();
    const posData = useSelector((state) => state?.posData);
    const vendorData = posData?.vendor;

    const parsePhotos = (photos) => {
        if (!photos) return [];
        if (Array.isArray(photos)) return photos;
        try {
            return typeof photos === 'string' ? JSON.parse(photos) : [];
        } catch (e) {
            console.error("Error parsing photos:", e);
            return [];
        }
    };

    const foodPhotos = parsePhotos(vendorData?.food_photos);
    const ambiancePhotos = parsePhotos(vendorData?.ambiance_photos);
    const [uploadResPhotos, { isLoading: isUploadingRes }] = useUploadResPhotosMutation();
    const [deleteResPhoto] = useDeleteResPhotoMutation();

    const [photoModal, setPhotoModal] = useState({ open: false, type: "" });

    const handleOpenPhotoModal = (type) => {
        setPhotoModal({ open: true, type });
    };

    const handleClosePhotoModal = () => {
        setPhotoModal({ open: false, type: "" });
    };

    const handleUploadResPhotos = async (formData) => {
        try {
            const response = await uploadResPhotos(formData).unwrap();
            if (response.status === 200) {
                if (response.data) {
                    dispatch(setPOSData({
                        ...posData,
                        vendor: {
                            ...posData.vendor,
                            [photoModal.type === 'food' ? 'food_photos' : 'ambiance_photos']: response.data
                        }
                    }));
                }
            }
        } catch (error) {
            console.log(error?.data?.message || "Failed to upload photos");
        }
    };

    const handleDeleteResPhoto = async (type, photoPath) => {
        try {
            const response = await deleteResPhoto({ photo_type: type, photo_path: photoPath }).unwrap();
            if (response.status === 200) {
                if (response.data) {
                    dispatch(setPOSData({
                        ...posData,
                        vendor: {
                            ...posData.vendor,
                            [type === 'food' ? 'food_photos' : 'ambiance_photos']: response.data
                        }
                    }));
                }
            }
        } catch (error) {
            console.log(error?.data?.message || "Failed to delete photo");
        }
    };

    return (
        <>
            <ManagePhotosContainer
                restaurantName={vendorData?.name}
                foodPhotos={foodPhotos}
                ambiancePhotos={ambiancePhotos}
                onAddResPhoto={handleOpenPhotoModal}
                onDeleteResPhoto={handleDeleteResPhoto}
                isLoading={!vendorData}
            />
            <AddPhotosModal
                open={photoModal.open}
                type={photoModal.type}
                onClose={handleClosePhotoModal}
                onUpload={handleUploadResPhotos}
                isLoading={isUploadingRes}
            />
        </>
    );
};

export default ManagePhotos;
